// =============================================================================
// TICKETS PAGES LAYOUTS
// =============================================================================

export default {
  path: 'ticketing',
  component: () => import('../../views/admin/tickets/index.vue'),
  children: [
    {
      path: 'support',
      component: () => import('../../views/admin/tickets/supportTicket/list/supportTicketChatList.vue'),
      children: [
        {
          path: '',
          name: 'supportTickets',
          component: () => import(/* webpackChunkName: "supportTickets" */ '../../views/admin/tickets/supportTicket/list/index'),
          meta: {
            permission: 'support_ticket.show',
            pageTitle: 'تیکت ها',
            pageTitleI18n: 'pages.tickets.support.list.title',
            layoutStatus: 'chat'
          // rule: 'editor'
          }
        },
        {
          path: 'insert',
          name: 'insertSupportTicket',
          component: () => import(/* webpackChunkName: "insertSupportTicket" */ '../../views/admin/tickets/supportTicket/profile/supportTicketDetail.vue'),
          meta: {
            permission: 'support_ticket.create',
            pageTitle: 'افزودن تیکت جدید',
            pageTitleI18n: 'pages.tickets.support.insert.title',
            layoutStatus: 'chat'
          // rule: 'editor'
          }
        },
        {
          path: ':id',
          name: 'supportTicketDetail',
          component: () => import(/* webpackChunkName: "supportTicketDetail" */ '../../views/admin/tickets/supportTicket/profile/supportTicketDetail.vue'),
          meta: {
            permission: 'support_ticket.show',
            pageTitle: '',
            pageTitleI18n: 'pages.tickets.support.detail.title',
            layoutStatus: 'chat'
          // rule: 'editor'
          }
        }
      ]
    }
  ]
}
